import { Tenant } from 'TenantModule/types';
import { postApiGalaxyServer } from 'services';
import { Realm } from 'types';

export type InitializeSubscriptionRealmSuccessResponse = unknown;

export type InitializeSubscriptionRealmFailureResponse = {
  error: string;
  message: string;
  statusCode: number;
};

export type InitializeSubscriptionRealmPayload = {
  tenant: Tenant['tenantName'];
  realmId: Realm['realm_id'];
};

export const initializeSubscriptionRealm = ({
  params: body,
  token,
  config = {},
}: BaseApiParams<InitializeSubscriptionRealmPayload>) => {
  return postApiGalaxyServer('/realm/initializeFirstSubscription', body, config, token);
};
